/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_CarddetailsInputs */

const en_visa_e2_carddetails = /** @type {(inputs: Visa_E2_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporary treaty-based classifications for qualifying trade or investment activity involving eligible treaty-country nationals.`)
};

const pt_visa_e2_carddetails = /** @type {(inputs: Visa_E2_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificações temporárias baseadas em tratado para atividade qualificada de comércio ou investimento envolvendo nacionais de países elegíveis.`)
};

const es_visa_e2_carddetails = /** @type {(inputs: Visa_E2_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificaciones temporales basadas en tratado para actividad calificada de comercio o inversión que involucra nacionales de países elegibles.`)
};

/**
* | output |
* | --- |
* | "Temporary treaty-based classifications for qualifying trade or investment activity involving eligible treaty-country nationals." |
*
* @param {Visa_E2_CarddetailsInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_carddetails = /** @type {((inputs?: Visa_E2_CarddetailsInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_CarddetailsInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_carddetails(inputs)
	if (locale === "es") return es_visa_e2_carddetails(inputs)
	return en_visa_e2_carddetails(inputs)
});